












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ViewResourceViewsModal from './ViewResourceViews.modal.vue'
import { EventBus } from '@/utils/event-bus'
import { saveAs } from 'file-saver'
import { lookup } from 'mime-types'
import axios from 'axios'

@Component({
  components: {
    ViewResourceViewsModal
  }
})
export default class OverviewResources extends Vue {
  @Prop() dateTo?: Date;
  @Prop() dateFrom?: Date;
  @Prop() marketKey?: string;
  @Prop() markets?: any;
  @Prop() componentReadyCount?: number;
  resources: any = []
  fields: any[] = [{ key: 'actions', label: 'Actions' }, { key: 'name', label: 'Name' }, { key: 'fileext', label: 'File type', class: 'text-center' }, { key: 'previewCount', label: 'Previews', class: 'text-center' }, { key: 'downloadCount', label: 'Downloads' }]

  @Watch('markets')
  @Watch('dateTo')
  @Watch('dateFrom')
  @Watch('marketKey')
  async getResources () {
    const eventType = 3
    await this.$store.dispatch('getPageViews', { dateTo: this.dateTo, dateFrom: this.dateFrom, eventType: eventType, marketKey: this.marketKey }).then((res: any) => {
      this.resources = res
      this.$emit('increment')
    })
  }

  formatDate (date: string) {
    // format date with time
    return new Date(date).toLocaleString()
  }

  get currentMarket () {
    const market = this.markets.find((market: any) => market.value === this.marketKey)
    return market.text
  }

  get topResources () {
    const sortedResources = this.resources.sort((a: { totalCount: number }, b: { totalCount: number }) => b.totalCount - a.totalCount)
    const resources = sortedResources.length ? sortedResources.slice(0, 20) : []
    return resources
  }

  async downloadFile (resource: any) {
    EventBus.$emit('show-loader')
    const resp = await axios.get(`resources/download/${resource.key}`, { withCredentials: true, responseType: 'blob' })
    if (!resp || resp.status !== 200) {
      EventBus.$emit('hide-loader')
      return
    }
    // log event
    this.$store.dispatch('addEvent', { description: 'Resource download', data: { key: resource.key }, title: 'Resource download', eventType: 3, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: resource.trackingkey })
    const _blob = new Blob([resp.data], { type: lookup(resource.filename as string) || undefined })
    saveAs(_blob, resource.filename)
    EventBus.$emit('hide-loader')
  }
}
